import { API, Storage, graphqlOperation } from 'aws-amplify';

import { listManuals } from '../graphql/queries';

export const MANUAL_STORAGE_LEVEL = 'public';
export const MANUAL_STORAGE_PREFIX = 'manuals';

// Signed download URL for a manual's storage key, or null on failure.
export const getManualUrl = async storageKey => {
  try {
    return await Storage.get(storageKey, {
      level: MANUAL_STORAGE_LEVEL,
      expires: process.env.REACT_APP_AMPLIFY_STORAGE_GET_EXPIRES,
      download: false,
    });
  } catch (e) {
    console.error('getManualUrl error', e);
    return null;
  }
};

// The Manual model has no keyed index, so listManuals is a DynamoDB scan and
// `limit` bounds the items scanned BEFORE the filter is applied — a small limit
// can return zero matches even when one exists. Page through until a match.
export const fetchActiveManualForPortal = async portal => {
  try {
    let nextToken = null;
    do {
      // eslint-disable-next-line no-await-in-loop
      const response = await API.graphql(
        graphqlOperation(listManuals, {
          filter: { portal: { eq: portal }, active: { eq: true } },
          limit: 1000,
          nextToken,
        }),
      );
      const page = response?.data?.listManuals;
      if (page?.items?.length) return page.items[0];
      nextToken = page?.nextToken ?? null;
    } while (nextToken);
    return null;
  } catch (e) {
    console.error('fetchActiveManualForPortal error', e);
    return null;
  }
};
